import React from 'react';
import { Prompt, Category } from '../types';
import ModalHeader from './ModalHeader';
import ImageSection from './modal/ImageSection';
import ContentFlow from './modal/ContentFlow';
import FooterActions from './modal/FooterActions';

interface PromptModalProps {
  prompt: Prompt;
  isOpen: boolean;
  onClose: () => void;
  onMarkerClick?: ( marker: string) => void;
  onEdit?: (prompt: Prompt) => void;
  onDelete?: (id: string) => void;
  userRole?: string;
  categories: Category[];
  currentUserId?: string;
}

const DesktopPromptModal: React.FC<PromptModalProps> = ({
  onMarkerClick,
  prompt,
  isOpen,
  onClose,
  onEdit,
  onDelete,
  userRole,
  categories,
  currentUserId,
}) => {
  const [copied, setCopied] = React.useState(false);

  const handleCopy = async () => {
    try {
      if (navigator.clipboard) {
        await navigator.clipboard.writeText(prompt.content);
      } else {
        const textArea = document.createElement('textarea');

        textArea.value = prompt.content;
        document.body.appendChild(textArea);
        textArea.select();
        document.execCommand('copy');
        document.body.removeChild(textArea);
      }

      setCopied(true);

      setTimeout(() => {
        setCopied(false);
      }, 2000);
    } catch (err) {
      console.error(
        'Erro ao copiar:',
        err
      );
    }
  };

  if (!isOpen) return null;

  const canManagePrompt =
    userRole === 'admin'
    ||
    prompt.userId === currentUserId;

  return (
    /* Overlay */
    <div
      className="
        fixed top-0 left-0 right-0 bottom-0 z-50
        flex
        items-center justify-center p-4
        bg-black/75
      "
    >
      {/* ModalShell */}
      <div
        className="
          bg-dark-800
          border border-dark-700
          overflow-x-hidden
          flex flex-col
          touch-pan-y
          rounded-lg
          max-w-[660px]
          w-full
          min-w-0
          mx-2
          sm:mx-4
          h-[90vh]
          min-h-0
          max-h-[90vh]
          overflow-hidden
        "
      >
        {/* Header */}
        <ModalHeader
          prompt={prompt}
          categories={categories}
          onClose={onClose}
        />

        {/* ScrollContainer */}
        <div className="flex-1 min-h-0 overflow-y-auto flex flex-col">
          {/* ImageSection */}
          <ImageSection
            imageUrl={prompt.imageUrl}
          />

          {/* ContentFlow */}
          <ContentFlow
            prompt={prompt}
            onMarkerClick={onMarkerClick}
          />

          {/* FooterActions */}
          <FooterActions
            copied={copied}
            handleCopy={handleCopy}
            canManagePrompt={canManagePrompt}
            prompt={prompt}
            onEdit={onEdit}
            onDelete={onDelete}
          />
        </div>
      </div>
    </div>
  );
};

export default DesktopPromptModal;
